'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'hot-tub-person';
var width = 512;
var height = 512;
var aliases = ["hot-tub"];
var unicode = 'f593';
var svgPathData = 'M96 128c35.33 0 64-28.67 64-64S131.3 0 96 0C60.67 0 32 28.67 32 64S60.67 128 96 128zM96 32c17.64 0 32 14.36 32 32S113.6 96 96 96S64 81.64 64 64S78.36 32 96 32zM281.6 110.8C305.3 123.9 320 148.9 320 176C320 184.8 327.3 192 336.1 192S352 184.8 352 176c0-38.7-21.02-74.44-57.61-94.75C270.7 68.09 256 43.09 256 16C256 7.156 248.9 0 240.1 0S224 7.156 224 16C224 54.7 245 90.44 281.6 110.8zM409.6 110.8C433.3 123.9 448 148.9 448 176C448 184.8 455.2 192 464 192S480 184.8 480 176c0-38.7-21.02-74.44-57.61-94.75C398.7 68.09 384 43.09 384 16C384 7.156 376.8 0 368 0S352 7.156 352 16C352 54.7 373 90.44 409.6 110.8zM47.1 240c8.844 0 16-7.156 16-16c0-17.64 14.36-32 32-32h50.7c5.797 0 11.5 1.578 16.47 4.562l68.59 41.16C234.3 239.3 237.2 240 239.1 240c5.438 0 10.73-2.766 13.73-7.766c4.547-7.578 2.094-17.41-5.484-21.95L179.6 169.1C169.7 163.2 158.3 160 146.7 160H95.1C60.7 160 31.1 188.7 31.1 224C31.1 232.8 39.15 240 47.1 240zM480 272H32c-17.67 0-32 14.33-32 32V448c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V304C512 286.4 497.6 272 480 272zM480 448c0 17.62-14.38 32-32 32H64c-17.62 0-32-14.38-32-32V304h448V448zM112 448C120.8 448 128 440.8 128 432V352c0-8.801-7.199-16-16-16S96 343.2 96 352v80C96 440.8 103.2 448 112 448zM208 448C216.8 448 224 440.8 224 432V352c0-8.801-7.199-16-16-16S192 343.2 192 352v80C192 440.8 199.2 448 208 448zM400 448c8.801 0 16-7.201 16-16V352c0-8.801-7.199-16-16-16S384 343.2 384 352v80C384 440.8 391.2 448 400 448zM304 448c8.801 0 16-7.201 16-16V352c0-8.801-7.199-16-16-16S288 343.2 288 352v80C288 440.8 295.2 448 304 448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHotTubPerson = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;